'use strict';

angular.module('ecrd.core')
    .provider('CoreConfiguration', function() {
        this.$get = ['CoreEcrd', function CoreConfiguration(CoreEcrd) {
            return CoreEcrd.getConfiguration();
        }];
    });
